import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { Admin, AdminDto } from '@app/store/shared/models';
import { AdminValue, AdminValueDto } from '../models';

@Injectable({
    providedIn: 'root',
})
export class HttpService {
    private httpClient = inject(HttpClient);

    getAdmin(id: string): Observable<Admin> {
        return this.httpClient.get<AdminDto>(`admins/${id}`).pipe(map((dto) => new Admin(dto)));
    }

    createAdmin(value: AdminValue): Observable<Admin> {
        const dto = new AdminValueDto(value);

        return this.httpClient.post<AdminDto>('admins', dto).pipe(map((response) => new Admin(response)));
    }

    updateAdmin(id: string, value: AdminValue): Observable<Admin> {
        const dto = new AdminValueDto(value);

        return this.httpClient.patch<AdminDto>(`admins/${id}`, dto).pipe(map((response) => new Admin(response)));
    }

    deleteAdmin(id: string): Observable<void> {
        return this.httpClient.delete<void>(`admins/${id}`);
    }
}
